module.exports = __webpack_public_path__ + "static/img/b_2_cross.36309bdf.png";